import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

import Hero from '../components/Hero';
import Footer from '../components/footer';
import Social from '../components/social';
import SectionHandler from '../components/sections/SectionHandler';
import Delayed from '../components/Delayed';
import DarkToggle from '../components/DarkToggle';
import Tutorial from '../components/Tutorial';
import { useLocalStorage } from '../components/LocalStorage';
import SEO from '../components/seo';
const ContentWrapper = styled.div`
  margin: auto;
  max-width: 40%;
  overflow-x: hidden;
  min-height: 100vh;
  @media (max-width: 768px) {
    max-width: 90%;
  }
`;
const StyledInputWrapper = styled.div`
  margin: 2rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IndexPage = () => {
  useEffect(() => {
    //printing log message
    var headstyles = [
      'font-weight:bold',
      'font-size:30px',
      'color:#40D1BA',
    ].join(';');
    var bodystyles = [
      'font-weight:bold',
      'font-size:20px',
      'font-style:italic',
      'color:#D9D8D4',
    ].join(';');
    console.log('%c Hi! Thanks for Visiting.', headstyles);
    console.log('%c leave a message', bodystyles);
  }, []);

  const [input, setinput] = useState(1);
  const [toShow, setToShow] = useLocalStorage('tutorial', true);
  function handleChange(e) {
    setinput(e.target.value);
    setToShow(false);
  }

  return (
    <ContentWrapper>
      <SEO title="Home" />
      <Hero heading={'Subhendu'} subheading={'Maji'} />

      <Delayed waitBeforeShow={2000}>
        <DarkToggle />
        <StyledInputWrapper>
          <input
            aria-label="page-handler"
            type="range"
            min="0"
            max="5"
            value={input}
            step="1"
            onChange={handleChange}
          />
        </StyledInputWrapper>

        <Tutorial toShow={toShow} />
        <SectionHandler input={input} />
        <Social />
      </Delayed>
      <Footer />
    </ContentWrapper>
  );
};

export default IndexPage;
